<template>
  <div class="time-table-roadmap">
    <div class="time-table-roadmap__header">
      <i-button
        class="ms-button-text"
        type="text"
        @click="goToContract"
      >
        Перейти к проекту
      </i-button>
      <div class="time-table-roadmap__customer ms-text">
        Заказчик: {{ customer }}
      </div>
    </div>
    <i-table
      border
      :disabled-hover="true"
      size="small"
      :columns="columns"
      :data="roadmap"
      :loading="loading"
      show-summary
      :summary-method="handleSummary"
    >
      <template v-for="item in slots" slot-scope="{ row, index }" :slot="item">
        <date-picker
          :key="item"
          @on-change="setData(index, item, $event)"
          v-model="row[item]"
          format="dd.MM.yyyy"
          :disabled="!getCommonModulePerms('time-table', 'update') || isDisabledPicker(item)"
        />
      </template>
      <template slot-scope="{ row, index }" slot="description">
        <i-input
          @on-change="setData(index, 'description', $event)"
          type="text"
          v-model="row.description"
          :disabled="!getCommonModulePerms('time-table', 'update')"
        />
      </template>
    </i-table>
    <div class="time-table-roadmap__controls" v-if="isChanged">
      <i-button
        type="primary"
        @click="saveRoadmap"
        :loading="saving"
        @change="isChanged = true"
      >
        Сохранить изменения
      </i-button>
    </div>
  </div>
</template>

<script>
import { columns } from '@/config/time-table'
import { getSummaryRow } from '@/utils'

const slots = [
  'plan_to_reporting_date',
  'fact_to_reporting_date',
  'plan_to_finalizing_date',
  'fact_to_finalizing_date',
  'plan_act_sign_date',
  'fact_act_sign_date',
  'plan_payment_date',
  'fact_payment_date'
]

export default {
  props: ['roadmap', 'loading', 'id', 'customer', 'index'],
  data () {
    return {
      isChanged: false,
      saving: false,
      columns,
      slots
    }
  },
  methods: {
    isDisabledPicker (item) {
      return ['fact_act_sign_date', 'fact_payment_date'].includes(item)
    },
    goToContract () {
      this.$store.commit('SET_COME_FROM', 'time-table')
      this.$router.push(`/app/contracts/${this.id}/overview`)
    },
    setData (index, name, e) {
      let value

      switch (name) {
        case 'description':
          value = e.target.value
          break
        default:
          value = e
      }

      this.roadmap[index][name] = value
      this.isChanged = true
    },
    async saveRoadmap () {
      try {
        this.saving = true
        const url = `page/roadmap?contract_id=${this.id}`
        const data = this.roadmap
        await this.$store.dispatch('POST_REQUEST', { url, data })
        this.saving = false
        this.isChanged = false
        this.$emit('save-roadmap', { index: this.index })
      } catch (error) {
        console.log(error)
        this.saving = false
      }
    },
    handleSummary (payload) {
      return getSummaryRow(payload, [3, 4])
    }
  }
}
</script>

<style lang="less">
.time-table-roadmap {
  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
  }

  .ivu-table {
    &-cell {
      word-break: break-word;

      .ivu-input {
        border: none;
        background-color: transparent;

        &[disabled] {
          background-color: transparent;
        }

        &:focus {
          box-shadow: none !important;
        }
      }
    }

    &-small td {
      height: 30px;

      .ivu-table-cell {
        padding: 0 4px;
      }
    }

    th {
      font-weight: 400;
      background-color: #fdfdfd;
    }

    .reports {
      background-color: #f0f5ff;
    }

    .acts {
      background-color: #f9f0ff;
    }

    .payments {
      background-color: #f6ffed;
    }
  }

  &__controls {
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;
  }
}

.dark {
  td.reports, th.reports {
    background-color: rgba(173, 198, 255, 0.15) !important;
  }
  td.acts, th.acts {
    background-color: rgba(211, 173, 247, 0.15) !important;
  }
  td.payments, th.payments {
    background-color: rgba(183, 235, 143, 0.15) !important;
  }
}
</style>
